import gql from 'graphql-tag'
import { default as fragments } from './fragments'

// NOTE: uncomment if we're replacing localstorage with graphql global state
// export const QUERY_LOGGED_IN_USER gql`
//   query {
//     loggedInUser @client {
//       emailAddress
//       userDecodedID
//       userNodeId
//       isPicsaEmployee
//       employer
//       responsibilities
//       identityResponsibilities
//     }
//   }
// `

export const QUERY_CONTACT = gql`
  query($identityId: UUID!) {
    contacts(identity_Id: $identityId) {
      edges {
        node {
          id
          employer {
            id
          }
        }
      }
    }
  }
`
export const QUERY_CONTACTS = gql`
  query($employerId: UUID) {
    contacts(employerId: $employerId) {
      edges {
        node {
          id
          employer {
            id
          }
          identity {
            id
            firstName
            lastName
          }
        }
      }
    }
  }
`

export const QUERY_ACCOUNT_TYPE = gql`
  query {
    accounttypes {
      edges {
        node {
          id
          name
        }
      }
    }
  }
`
export const QUERY_TRANSACTION_TYPE = gql`
  query {
    transactiontypes {
      edges {
        node {
          id
          name
        }
      }
    }
  }
`
export const QUERY_TRANSACTION_STATUS = gql`
  query {
    transactionstatuses {
      edges {
        node {
          id
      		name
        }
      }
    }
  }
`
export const QUERY_EMPLOYER = gql`
  query($id: ID!) {
    employer(id: $id) {
      id
      friendlyName
      hasSmsApiAccess
      smsApiKey
      smsApiIdentityNodeId
      hasPayslipApiAccess
      payslipApiKey
      payslipApiIdentityNodeId
      identity {
        id
      }
    }
  }
`

export const QUERY_EMPLOYERS = gql`
  query {
    employers(orderBy: "friendly_name") {
      edges {
        node {
          id
          friendlyName
        }
      }
    }
  }
`
export const QUERY_DIVISIONS_BY_EMPLOYER = gql`
  query($employer: UUID) {
    divisions(employer_Id: $employer) {
      edges {
        node {
          id
          name
        }
      }
    }
  }
`
export const QUERY_PAYROLLCYCLES_BY_EMPLOYER = gql`
  query($employer: UUID) {
    payrollcycles(employer_Id: $employer) {
      edges {
        node {
          id
          name
        }
      }
    }
  }
`
export const QUERY_EMPLOYERGROUPS = gql`
  query {
    employergroups(orderBy: "friendly_name") {
      edges {
        node {
          id
          friendlyName
        }
      }
    }
  }
`
export const QUERY_FILE = gql`
  query($id: ID!) {
    file(id: $id) {
      id
      asset
      url
      source
      trash
      children {
        edges {
          node {
            id
          }
        }
      }
      relations {
        edges {
          node {
            id
            objectId
            contentType {
              id
              model
            }
          }
        }
      }
    }
  }
`
export const QUERY_FILETYPE = gql`
  query {
    filetypes {
      edges {
        node {
          id
          name
        }
      }
    }
  }
`
export const QUERY_REQUESTRUN = gql`
  query($id: ID!) {
    requestrun(id: $id) {
      ...RequestRun
    }
  }
  ${fragments.requestRun}
`
export const QUERY_REQUESTTYPE = gql`
  query($id: ID!) {
    requesttype(id: $id) {
      ...RequestType
    }
  }
  ${fragments.requestType}
`
export const QUERY_REQUESTTYPES = gql`
  query($audience: String, $source: String) {
    requesttypes(audience: $audience, source: $source) {
      edges {
        node {
          id
          name
          content
          audience
          workflow {
            id
          }
        }
      }
    }
  }
`
export const QUERY_CASERELATIONS = gql`
  query($objectId: UUID) {
    caserelations(objectId: $objectId, orderBy: "-created_at") {
      edges {
        node {
          id
          case {
            id
            priority
            productType
            requestType
            createdAt
            status
            nextActionAt
          }
        }
      }
    }
  }
`
export const QUERY_IDENTITIES_BY_IDENTITYVALUE = gql`
  query($identityValue: String!) {
    identities(identityValue: $identityValue) {
      edges {
        node {
          id
          firstName
          lastName
          identityValue
          isContact
          language
          addresses {
            edges {
              node {
                id
                addressType
                addressValue
                default
                optedOut
                inactive
              }
            }
          }
          client {
            id
            division {
              id
              name
              employer {
                id
                friendlyName
              }
            }
          }
        }
      }
    }
  }
`

export const QUERY_EMAIL = gql`
  query($id: ID!) {
    email(id: $id) {
      id
      fromAddr
      subject
      textBody
      toAddrs
      createdAt
      attachments {
        id
        asset
        url
        children {
          edges {
            node {
              id
              asset
              url
            }
          }
        }
      }
      toIdentities {
        id
        firstName
        lastName
      }
    }
  }
`

export const QUERY_MUTATE_WORKFLOWRUNSTEP = gql`
  mutation ($input: WorkflowRunStepMutationInput!) {
    workflowrunstepMutate(input: $input) {
      workflowrunstep {
        id
        status
      }
    }
  }
`

export const QUERY_EMPLOYER_SOLUTION = gql`
  query($identityId: ID!, $status: String!) {
    identity(id: $identityId) {
      id
      fullName
      employer {
        id
        employersolutions(status: $status) {
          edges {
            node {
              id
              activeAt
              billableEmployees
              deprecateAt
              solution {
                name
                participation
              }
            }
          }
        }
      }
    }
  }
`

export const QUERY_EMPLOYER_SOLUTION_PRODUCTS = gql`
  query($solution: UUID!, $orderBy: String) {
    employerproducts(employersolution_Id: $solution, orderBy: $orderBy) {
      edges {
        node {
          id
          activeAt
          billingType
          clientMatchingRequired
          clientMatchingRules
          costClient
          costEmployer
          deprecateAt
          discountOffBase
          employerShortCode
          exceptionRules
          product {
            name
            family
          }
        }
      }
    }
  }
`

export const QUERY_FILERELATIONS = gql`
  query($file: UUID, $contentType: ID, $objectId: UUID) {
    filerelations(file_Id: $file, contentType_Id: $contentType, objectId: $objectId, orderBy: "-created_at") {
      edges {
        node {
          id
          file {
            id
            filetype {
              id
            }
          }
          objectId
        }
      }
    }
  }
`

export const QUERY_PAYSLIPS = gql`
  query($identityId: UUID) {
    payslips(identity_Id: $identityId, orderBy: "-created_at") {
  		edges {
        node {
          id
          payday
          basicGross
          totalGross
          totalDeductions
          nonPicsaDebtDeductions
          loanapplication {
            id
          }
          creditapplications {
            edges {
              node {
                id
              }
            }
          }
          payrollrun {
            id
            workflowrunDeducting {
              id
            }
          }
          identity {
            id
            fullName
          }
        }
      }
    }
  }
`

export const QUERY_PAYSLIP = gql`
  query($id: ID!) {
    payslip(id: $id) {
      id
      payday
      basicGross
      totalDeductions
      nonPicsaDebtDeductions
      loanapplication {
        id
      }
      creditapplications {
        edges {
          node {
            id
            createdAt
            status
            amountAppliedFor
          }
        }
      }
      payrollrun {
        id
        payrollcycle {
          id
          name
        }
      }
      identity {
        id
        fullName
      }
    }
  }
`
export const QUERY_IDENTITY_BANKACCOUNTS = gql`
  query($uuid: UUID!, $status: String) {
    identitybankaccounts(identity_Id: $uuid, status: $status) {
      edges {
        node {
          ...IdentityBankAccount
        }
      }
    }
  }
  ${fragments.identityBankAccount}
`
export const QUERY_EMPLOYERGROUP_EMPLOYERS = gql`
  query($employerGroupId: UUID!) {
    employers(employergroup_Id: $employerGroupId) {
      edges {
        node {
          id
          friendlyName
        }
      }
    }
  }
`
export const QUERY_EMPLOYER_DIVISIONS = gql`
  query($employerId: UUID!) {
    divisions(employer_Id: $employerId) {
      edges {
        node {
          id
          name
        }
      }
    }
  }
`
export const QUERY_BULKMESSAGE = gql`
  query($id: ID!) {
    bulkmessage(id: $id) {
      id
      content
      description
      status
      createdAt
      scheduledAt
      numberOfFailedMessages
      hasUnsentMessages
      audience {
        id
        name
        archived
        identities {
          totalCount
        }
      }
      channels {
        edges {
          node {
            id
          }
        }
      }
      messages {
        totalCount
        edges {
          node {
            id
            status
          }
        }
      }
      telegrammessages {
        totalCount
        edges {
          node {
            id
            status
          }
        }
      }
    }
  }
`
export const QUERY_CHANNEL = gql`
  query($id: ID!) {
    channel(id: $id) {
      id
      inboundAddr
      outboundAddr
    }
  }
`



// WEBPACK FOOTER //
// ./src/queries.js